import { animateFlyToCart, bumpCartIcon } from './cartAnimation';

function getCartTargetEl() {
  const isDesktop = typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia('(min-width: 992px)').matches
    : true;

  return document.getElementById(isDesktop ? 'header-cart-icon-desktop' : 'header-cart-icon-mobile')
    || document.getElementById('header-cart-icon-desktop')
    || document.getElementById('header-cart-icon-mobile');
}

function getSourceImageEl(clickTarget) {
  if (!clickTarget?.closest) return null;
  const card = clickTarget.closest('.product-card');
  if (!card) return null;
  return card.querySelector('img');
}

export function addToCartAnimated({ event, product, addToCart, quantity = 1 }) {
  // Always add to cart first (must never fail because of animation)
  addToCart(product, quantity);

  try {
    const cartEl = getCartTargetEl();
    if (cartEl) bumpCartIcon(cartEl);

    const sourceEl = event?.currentTarget ? getSourceImageEl(event.currentTarget) : null;
    if (sourceEl && cartEl) animateFlyToCart({ sourceEl, cartEl });
  } finally {
    // Let header react (cart bump + optional header peek)
    window.dispatchEvent(new Event('delice:cart:add'));
  }
}

